var removePagination = document.querySelectorAll(".pagination, .pagination-border-top, .pagination-custom, .Pagination, .justify-content-center, .collection-pagination, .box__paginate, .paginate, .pagination--container, #pagination, .collection--pagination");
removePagination[0].style.display="none"; 
        window.onload=function(){
            var eoShFileExist=document.querySelector("script[src*='https://loadmore-infinitescroll.extendons.com']"); 
            if(eoShFileExist==null){ 
                removePagination[0].style.display="block"; 
            }
        }